import { useParams, Link as RouterLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getAMIFileHashes } from '../services/api';
import { Container, Typography, CircularProgress, Alert, Paper, Box } from '@mui/material';
import Navbar from '../components/Navbar';

const Hashes = () => {
  const { imageId } = useParams();
  const [hashes, setHashes] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (imageId) {
      setLoading(true);
      setError(null);
      getAMIFileHashes(imageId)
        .then(res => {
          setHashes(res.data);
          setLoading(false);
        })
        .catch(() => {
          setError('Failed to fetch file hashes');
          setLoading(false);
        });
    }
  }, [imageId]);

  return (
    <Container maxWidth={false} disableGutters sx={{ width: '80vw', mx: 'auto', mt: 4, pb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', mb: 4 }}>
        <Navbar />
      </Box>
      <Typography variant="h5" gutterBottom>
        File Hashes for Image {imageId}
      </Typography>
      <Typography sx={{ mb: 2 }}>
        <RouterLink to={`/image/${imageId}`}>← Back to Image Details</RouterLink>
      </Typography>
      <Paper sx={{ p: 2, mt: 2, width: '100%', boxSizing: 'border-box', overflowX: 'auto' }}>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <pre style={{ width: '100%', whiteSpace: 'pre', margin: 0, overflowX: 'auto' }}>{hashes}</pre>
        )}
      </Paper>
    </Container>
  );
};

export default Hashes; 